/**
 * Cryptographic utility functions for secure random number and ID generation.
 * Replaces Math.random() for security-sensitive operations (invoice numbers, tokens, IDs).
 */

export const getSecureRandomInt = (min = 100000, max = 999999) => {
  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    const range = max - min + 1;
    return min + (array[0] % range);
  }
  // Cryptographic fallback for environments where window.crypto might be polyfilled or in tests
  try {
    const cryptoObj = typeof crypto !== "undefined" ? crypto : null;
    if (cryptoObj && cryptoObj.getRandomValues) {
      const array = new Uint32Array(1);
      cryptoObj.getRandomValues(array);
      const range = max - min + 1;
      return min + (array[0] % range);
    }
  } catch {
    // ignore
  }
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getSecureRandomId = (prefix = "ID") => {
  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
    const array = new Uint32Array(2);
    window.crypto.getRandomValues(array);
    return `${prefix}-${array[0].toString(36)}${array[1].toString(36)}`;
  }
  return `${prefix}-${Date.now()}`;
};
